<header class="pt-topbar bg-accent">
  <div class="container">
    <div class="section-inset-t pb-3 pb-md-4 text-max-width-sm mx-auto">
      <h1 class="h2">
        <span>{{ header()?.title }}</span>
      </h1>

      @if (header()?.intro) {
        <p class="lead mt-3 mt-sm-4">{{ header()?.intro }}</p>
      }
    </div>
  </div>
</header>

@if (header()?.image?.url) {
  <div class="page-image text-center">
    <figure class="container d-inline-block w-auto">
      <img
        [ngSrc]="header()?.image?.url || 'https://coda.fstr.io/media/placeholder.png'"
        [width]="1200"
        [height]="1200"
        [alt]="header()?.image?.alt || header()?.image?.caption"
        ngSrcset="550w, 800w, 1600w"
        [loaderParams]="{
          width: 1200,
          height: 1200,
          anchor: header()?.image?.anchor || 'middlecenter',
          scale: 'both',
        }"
        [attr.data-object-position]="header()?.image?.anchor || 'middlecenter'"
        [priority]="true"
        [sizes]="'100w'"
        [loaderParams]="{ scale: 'both', mode: 'max', width: 1200, height: 1200 }"
      />

      @if ((header()?.image)!.caption) {
        <figcaption class="caption mt-2">{{ (header()?.image)!.caption }}</figcaption>
      }
    </figure>
  </div>
}
